// extracted by mini-css-extract-plugin
export var image = "results-module--image--deacb";
export var imageFallback = "results-module--imageFallback--fe6bc";
export var readMore = "results-module--readMore--de627";
export var result = "results-module--result--770cd";
export var results = "results-module--results--a6bde";